import { Action, Reducer } from "redux";
import { TimeZoneState, TimeZoneTypes, TimeZoneActionTypes } from "./timeZoneTypes";

export const INITIAL_STATE: TimeZoneState = {
	timeZone: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
};

const timeZoneReducer: Reducer<TimeZoneState> = (state: TimeZoneState = INITIAL_STATE, action: Action) => {
	const actionTypes = action as TimeZoneActionTypes;
	switch (actionTypes.type) {
		case TimeZoneTypes.GET_TIMEZONES_USER:
			return {
				...state,
				timeZone: { ...state.timeZone, isLoading: true },
			};
		case TimeZoneTypes.SAVE_TIMEZONES_USER:
			return {
				...state,
				timeZone: {
					...state.timeZone,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case TimeZoneTypes.RESET_REDUCER_TIMEZONES_USER:
			return {
				...state,
				timeZone: INITIAL_STATE.timeZone,
			};
		default:
			return state;
	}
};

export default timeZoneReducer;
